let children = [];

//------------ ADMINISTRACION -------------------------
children.push({
  path: "/administracion/evento",
  name: "MNG_INDUCTION",
  component: () => import("../views/Management/Instruction.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      { text: "Eventos de Personal", href: "/administracion/evento" },
    ],
  },
});
children.push({
  path: "/administracion/historialcontrolacceso",
  name: "MNG_ACCESSCONTROL_REPORT",
  component: () => import("../views/Management/AccessControlReport.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Historial de Control de Acceso",
        href: "/administracion/historialcontrolacceso",
      },
    ],
  },
});
children.push({
  path: "/administracion/combustible",
  name: "MNG_FUELVOUCHER",
  component: () => import("../views/Management/FuelVoucher/FuelVoucher.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "combustible",
        href: "/administracion/combustible",
      },
    ],
  },
});
children.push({
  path: "/administracion/vehiculo",
  name: "MNG_VEHICLE",
  component: () => import("../views/Management/Vehicle/Vehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Vehículo",
        href: "/administracion/vehiculo",
      },
    ],
  },
}); 
children.push({
  path: "/administracion/archivero",
  name: "MNG_ARCHIVIST",
  component: () => import("../views/Management/Archivist/Archivist.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Archivero",
        href: "/administracion/archivero",
      },
    ],
  },
});
children.push({
  path: "/administracion/salidaequipo",
  name: "SALEPPTI",
  component: () => import("../views/Management/MngAuthorizedExEpp.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Salida de equipo",
        href: "/administracion/salidaequipo",
      },
    ],
  },
});
children.push({
  path: "/administracion/lectorsalidaequipo",
  name: "LECSALDEPPTI",
  component: () => import("../views/Management/ReaderExitEquip.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Lector",
        href: "/administracion/lectorsalidaequipo",
      },
    ],
  },
});
children.push({
  path: "/administracion/programacion",
  name: "MNG_PROGRAMMINGVEHICLE",
  component: () => import("../views/Management/ProgrammingVehicle/ProgrammingVehicle.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Programación",
        href: "/administracion/programacion",
      },
    ],
  },
});
//Nueva Opcion
children.push({
  path: "/administracion/detracciones",
  name: "MNG_DETRACTION",
  component: () => import("../views/Management/Detraction/Detraction.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      { text: "Detracción", href: "/administracion/detraccion" },
    ],
  },
});
children.push({
  path: "/administracion/pagosrecibidos",
  name: "MNG_OUTGOING_PAYMENTS",
  component: () => import("../views/Management/Treasury/OutgoingPayments.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      { text: "Pagos Recibidos", href: "/administracion/pagosrecibidos" },
    ],
  },
});
children.push({
  path: "/administracion/pagosmasivos",
  name: "MNG_PAYMENTS",
  component: () => import("../views/Management/Detraction/Payments.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      { text: "Pagos Masivos", href: "/administracion/pagosmasivos" },
    ],
  },
});

children.push({
  path: "/administracion/parking",
  name: "MNG_PARKING",
  component: () => import("../views/Management/Parking/Parking.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Vehículo",
        href: "/administracion/parking",
      },
    ],
  },
});

children.push({
  path: "/administracion/validateaccess",
  name: "MNG_VALIDATE_ACCESS",
  component: () => import("../views/Management/Parking/ValidateAccess.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Vehículo",
        href: "/administracion/validateaccess",
      },
    ],
  },
});
children.push({
  path: "/administracion/validateaccesslist",
  name: "MNG_PARKING_ACCESS",
  component: () => import("../views/Management/Parking/ValidateAccessList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Vehículo",
        href: "/administracion/validateaccesslist",
      },
    ],
  },
});

children.push({
  path: "/administracion/reserva_sala",
  name: "MNG_ROOM_RESERVATION",
  component: () => import("../views/Management/Room/MngRoomReservation.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      {
        text: "Reserva de Sala",
        href: "/administracion/reserva_sala",
      },
    ],
    title: 'ADM-Reserva de Sala',
  },
});

children.push({
  path: "/administracion/salas/calendario",
  name: "MNG_HALL_CALENDAR",
  component: () => import("../views/Management/Room/MngRoomView.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Administración", disabled: true },
      { text: "Salas", disabled: true },
      {
        text: "Calendario",
        href: "/administracion/salas/calendario",
      },
    ],
  },
}); 

//------------ CAPACITACIONES (NUEVO SISTEMA) -------------------------
children.push({
  path: "/management/training/topics",
  name: "MNG_TRAINING_TOPICS",
  component: () => import("../views/Management/Training/Topic/TrainingTopicList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Temas de Capacitación", href: "/management/training/topics" },
    ],
    title: "Temas de Capacitación",
  },
});

children.push({
  path: "/management/training/trainers",
  name: "MNG_TRAINERS",
  component: () => import("../views/Management/Training/Trainer/TrainerList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Capacitadores", href: "/management/training/trainers" },
    ],
    title: "Capacitadores",
  },
});

children.push({
  path: "/management/training/events",
  name: "MNG_TRAINING_EVENTS",
  component: () => import("../views/Management/Training/Event/TrainingEventList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Eventos de Capacitación", href: "/management/training/events" },
    ],
    title: "Eventos de Capacitación",
  },
});

children.push({
  path: "/management/training/sessions",
  name: "MNG_TRAINING_SESSIONS",
  component: () => import("../views/Management/Training/Session/TrainingSessionList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Sesiones de Capacitación", href: "/management/training/sessions" },
    ],
    title: "Sesiones de Capacitación",
  },
});

children.push({
  path: "/management/training/participants",
  name: "MNG_TRAINING_PARTICIPANTS",
  component: () => import("../views/Management/Training/Participant/TrainingParticipantList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Participantes", href: "/management/training/participants" },
    ],
    title: "Participantes de Capacitación",
  },
});

children.push({
  path: "/management/training/attendance",
  name: "MNG_TRAINING_ATTENDANCE",
  component: () => import("../views/Management/Training/Attendance/TrainingAttendanceList.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Asistencia por Sesión", href: "/management/training/attendance" },
    ],
    title: "Asistencia por Sesión",
  },
});

children.push({
  path: "/management/training/dashboard",
  name: "MNG_TRAINING_DASHBOARD",
  component: () => import("../views/Management/Training/Dashboard/TrainingDashboard.vue"),
  meta: {
    authenticated: true,
    breadcrumb: [
      { text: "Inicio", href: "/#/" },
      { text: "Capacitaciones", disabled: true },
      { text: "Dashboard de Cobertura", href: "/management/training/dashboard" },
    ],
    title: "Dashboard de Cobertura",
  },
});

export { children };
